/**
 * Maps product / supplement form labels to FSSAI cut-off state (Solid | Liquid).
 */
export function mapProductFormNameToFssaiState(
  formName?: string | null,
  description?: string | null
): string | undefined {
  const desc = (description || '').trim().toLowerCase();
  if (desc === 'solid' || desc === 'dry') {
    return 'Solid';
  }
  if (desc === 'liquid') {
    return 'Liquid';
  }

  const name = (formName || '').trim();
  if (!name) {
    return undefined;
  }

  const lower = name.toLowerCase();
  if (lower === 'solid' || lower === 'dry') {
    return 'Solid';
  }
  if (lower === 'liquid') {
    return 'Liquid';
  }

  const liquidKeywords = [
    'liquid',
    'syrup',
    'solution',
    'suspension',
    'emulsion',
    'drop',
    'tonic',
    'drink',
    'beverage',
    'shot',
    'elixir',
  ];
  if (liquidKeywords.some((keyword) => lower.includes(keyword))) {
    return 'Liquid';
  }

  return 'Solid';
}

export function resolveFssaiStateFromFormOption(option: {
  name?: string;
  description?: string;
} | null | undefined): string | undefined {
  if (!option) {
    return undefined;
  }
  return mapProductFormNameToFssaiState(option.name, option.description);
}
